// extracted by mini-css-extract-plugin
export default {"container":"SideMenu_container__sVyva","menuList":"SideMenu_menuList__lD5DQ","picked":"SideMenu_picked__0JdDF","closedMenu":"SideMenu_closedMenu__W4H82"};